import axios from "axios";
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";

export default function VerifyOTP() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  //  console.log("Received Email:" , email);

  useEffect(() => {
    if (!email) {
      navigate("/auth/forgotpassword");
    }
  }, [email, navigate]);

  const handleOtp = async (e) => {
    e.preventDefault();
    // console.log(email);
    const loadingToast = toast.loading("please wait ");
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/admin/admin-verifyOtp`,
        {
          email,
          otp,
        }
      );
      // console.log("ertyui", res);
      if (res.data.statusCode === 200) {
        setTimeout(() => {
          navigate(
            "/auth/update-password",
            { state: { securityToken: res.data.result.securityToken, email } },
            { state: { email } }
          );
        }, 1500);

        toast.success("otp verified successfully");
      } else {
        toast.error("Wrong OTP");
      }
    } catch (error) {
      toast.error("Invalid Error! Please try again later");
    } finally {
      toast.dismiss(loadingToast);
    }
  };
  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Verify OTP
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">Enter your OTP !</p>

        <form className="gap-8  space-y-4" onSubmit={handleOtp}>
          <OTPInput
            value={otp}
            onChange={(value) => {
              setOtp(value);
              // setError("");
            }}
            numInputs={5}
            renderInput={(props) => (
              <input
                {...props}
                placeholder="-"
                inputMode="numeric"
                maxLength={1}
                pattern="[0-9]*"
                style={{
                  boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
                }}
                className="
                    mx-1 h-14
                    w-14 rounded-lg
                    border-2
                    border-gray-300
                    bg-white
                    text-center text-2xl font-semibold text-gray-800
                    placeholder-gray-300 shadow-md
                    transition-all duration-300 hover:shadow-xl focus:border-purple-500
                    focus:outline-none
                    focus:ring-2
                    focus:ring-purple-300
                    disabled:cursor-not-allowed disabled:bg-gray-100
                    "
              />
            )}
            containerStyle={{ justifyContent: "space-evenly", gap: "6px" }}
          />

          <button className="linear mt-10 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
            Verify OTP
          </button>
        </form>
        <div className=" mb-4 mt-5 flex items-center justify-between px-2">
        <Link
          to="/auth/forgot-password"
          className="mt-15 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
        >
          {" "}
          Back to Forgot Password!
        </Link>
        </div>
      </div>
    </div>
  );
}
